import { analytics as analyticsWidget } from "instantsearch.js/es/widgets"

export const siteAnalytics = analyticsWidget({
  pushFunction(formattedParameters, state, results) {
    dataLayer.push({
      event: 'search',
      'Search Query': state.query,
      'Facet Parameters': formattedParameters,
      'Number of Hits': results.nbHits
    })
  },
  delay: 3000
})
